export default {
  navText: 'Navigation',
};
